import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import TemplateFactory from "../Templates/TemplateFactory";
import BlogAPIClient from "../../api/clients/blog";
import { arrEmpty } from "../Helpers";
import Loading from "../Components/Loading";
import { fetchTitlesOptions } from "../Components/TitleArea";

export default function Blog() {
  // router
  const location = useLocation();
  // state
  const [isLoading, setIsLoading] = useState(false);
  const [titleArea, setTitleArea] = useState(null);
  const [posts, setPosts] = useState(null);
  // vars
  let allowedToLoad = true;

  // get the banner content
  useEffect(() => {
    const loadBanner = async () => {
      setIsLoading(true);
      try {
        const API = new BlogAPIClient();
        const [response, titlesOptions] = await Promise.all([
          API.getPosts(),
          fetchTitlesOptions().catch(() => null),
        ]);
        if (response) {
          const blogTitle =
            titlesOptions?.special_pages?.blog_title || "The Know Quam Blog";
          // set title area
          setTitleArea({
            title: blogTitle,
            image: null,
            breadcrumbs: null,
          });
          setPosts(response);
        }
      } catch (err) {
        console.error(err);
      }
      setIsLoading(false);
    };

    // when safe to load
    {
      location.pathname !== "/_error" && allowedToLoad && loadBanner();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => (allowedToLoad = false);
  }, []); // run once initially

  // early exit
  if (arrEmpty(titleArea)) return null;

  return isLoading ? (
    <Loading inclIcon={true} />
  ) : (
    <TemplateFactory
      template={"blog-template"}
      title={titleArea}
      modules={posts}
    />
  );
}
